import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { useMediaQuery } from 'react-responsive';


import {AppBar, Toolbar, IconButton} from '@mui/material'

import SecurityIcon from '@mui/icons-material/Security';
import InstagramIcon from '@mui/icons-material/Instagram';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';


const ExtensionButton = props => {

  const navigate = useNavigate();
  const location = useLocation();
  const { extensionInstalled } = useSelector(state => state.api);

  const isDesktop= useMediaQuery({
    query: '(min-width: 1224px)'
  })

  const openExtensionPage= () => {
    var url = 'https://chrome.google.com/webstore/detail/trends/malnhaodjdegcljjebmpopbjmckblndn';
    window.open(url,'_blank');
  }

  const openPrivacy= () => {
    navigate('/privacy')
}

  const openInstagram= () => {
    var url = 'https://instagram.com/platforworld';
    window.open(url);
  }

  const openMail= () => {
    var url = 'mailto:memeek01@gmail.com';
    window.open(url);
  }

  const [isHovered, setIsHovered] = React.useState(false);

  return (
  <>
    <button
      type="button"
      onClick={openExtensionPage}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        cursor: 'pointer',
        fontSize: '18px',
        border: '1px solid rgba(15, 23, 42, 0.12)',
        padding: '12px 18px',
        minHeight: '56px',
        lineHeight: 1.2,
        borderRadius: '14px',
        backgroundColor: isHovered ? '#f8fafc' : '#ffffff',
        color: '#0f172a',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        letterSpacing: '0.01em',
        boxShadow: isHovered ? '0 12px 26px rgba(15, 23, 42, 0.11)' : '0 10px 24px rgba(15, 23, 42, 0.08)',
        transition: 'background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
        outline: 'none',
        appearance: 'none',
        WebkitAppearance: 'none'
      }}
    >
      <img src="img/chrome.svg" style={{width: '30px', height: '30px', paddingRight: '10px'}} alt="chrome extension logo" />
      {location.pathname === '/kr' ? '웹에서 발견한 것들을 저장하세요' : 'Save what you discovered on the insight board'}
    </button>
    {/* {
      isDesktop
      ?
        <a
          className="btn-lg page-scroll"
          onClick={openExtensionPage}
          style={{cursor: 'pointer', fontSize: '18px', border: '2px solid #ccc', padding: '5px 10px', borderRadius: '30px', backgroundColor: 'white'}}
        >
          <img src="img/chrome.svg" style={{width: '30px', height: '30px', paddingRight: '10px'}} alt="chrome extension logo" />
          {location.pathname=='/kr'? '브라우저에 스티커 기능을 추가하세요': 'Start saving anything'}
        </a>
      :
        <div>
          <a
            className="border btn-lg page-scroll"
            onClick={openExtensionPage}
            style={{cursor: 'pointer', border: '2px solid #ccc', padding: '5px 10px', borderRadius: '30px', }}
          >
            <img src="img/chrome.svg" style={{width: '30px', height: '30px', paddingRight: '10px'}} alt="chrome extension logo" />
            {location.pathname=='/kr'? '현재 PC 크롬에서 이용 가능하세요!': 'Now available on PC Chrome!'}
          </a>
        </div> 
    } */}
  </>
  );
}

export default ExtensionButton;